<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{ title }}</div>
    <div class="panel-body">
      <form name="company-block">
        <modal-dialog :handleClose="handleClose">
          <template v-slot:trigger="{ openModal }">
            <button
              @click.prevent="openModal"
              type="button"
              :class="`btn-${color} btn-block btn-small`">
              {{ buttonLabel }}
            </button>
          </template>
          <template v-slot:body="{ closeModal }">
            <div class="col-xs-12 clearfix">
              <div class="clearfix">
                <h4>{{ description }}</h4>
              </div>
              <div class="mb-20 mt-20">
                <button
                  @click.prevent="closeModal"
                  class="btn-gray-inverse btn-mid"
                  type="button">
                  Cancelar
                </button>&nbsp;
                <button
                  @click.prevent="handleSubmit"
                  :class="`btn-${color} btn-mid`"
                  type="submit">
                  Confirmar
                </button>
              </div>
            </div>
          </template>
        </modal-dialog>
      </form>
    </div>
  </div>
</template>

<script>
import ModalDialog from '@/components/ui/ModalDialog'

export default {
  components: {
    ModalDialog
  },
  props: [
    'action',
    'title',
    'buttonLabel',
    'description',
    'color'
  ],
  data () {
    return {
      handleClose: ''
    }
  },
  methods: {
    handleSubmit () {
      this.handleClose = false
      this.$emit('handleAction', this.action, {})
    }
  }
}
</script>
